import { render } from "./PrintProductsReception.vue?vue&type=template&id=abb37a72&scoped=true"
import script from "./PrintProductsReception.vue?vue&type=script&lang=js"
export * from "./PrintProductsReception.vue?vue&type=script&lang=js"

import "./PrintProductsReception.vue?vue&type=style&index=0&id=abb37a72&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abb37a72"]])

export default __exports__